import { MeetingsErrorCode } from "@api/enums/errors/Meetings";
import { BackendErrorInterface } from "@api/models/interfaces/BackendError";
import { MScheduleSlotCreateInterface } from "@api/models/interfaces/meetings-schedule/MeetingsScheduleSlotInterface";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";
import { MeetingRepository } from "@api/repositories/MeetingRepository";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { showNeedRightsModal } from "@service/helpers/ErrorModals";
import { MeetingsError } from "@share/meetings-schedule/helpers/MeetingsScheduleError"
import { AxiosError } from "axios";
import { DateTime } from "luxon";
import { Store } from "vuex";

export interface SlotInteractionServiceInterface {

    /**
     * booking slot for own or another user by userId, for own userId must be not defined
     * returns success or not
     * @param slot slot
     * @param userId userId - need for book for another user
     */
    book(slot: MScheduleSlot, userId?: number): Promise<MScheduleSlot | false>;
    cancelBooking(slot: MScheduleSlot, makeUnavaliable?: boolean): void;
    toggleAvaliable(slot: MScheduleSlot, userId?: number): void;
}

export class SlotInteractionService implements SlotInteractionServiceInterface {
    objectRepository: ObjectRepository;
    meetingsRepository: MeetingRepository;

    constructor(repositories: RepositoryFabric, private store: Store<any>) {
        this.objectRepository = repositories.get(RepositoryFabric.OBJECT);
        this.meetingsRepository = repositories.get(RepositoryFabric.MEETING);
    }

    book(slot: MScheduleSlot, userId?: number) {
        return this.createSlot(slot, userId);
    }

    cancelBooking(slot: MScheduleSlot) {
        this.deleteSlot(slot);
    }

    /**
     * Toggle slot availability
     * @param slot
     * @param userId
     */
    toggleAvaliable(slot: MScheduleSlot, userId?: number): void {

        if (slot.isNotAvailable && slot.id) {
            this.meetingsRepository.deleteSlot(slot.id);
        }
        else {
            slot.isNotAvailable = true;
            this.createSlot(slot, userId);
        }
    }

    private async createSlot(slot: MScheduleSlot, userId?: number) {

        const updateModel: MScheduleSlotCreateInterface = {
            beginAt: slot.beginAt as DateTime,
            isNotAvailable: slot.isNotAvailable || false,
            scheduleId: slot.scheduleId,
            ...(userId ? { userId } : null)
        }

        try {
            return await this.meetingsRepository.createSlot(updateModel);
        }
        catch(e) {
            this.handleError(e);
            return false;
        }
    }

    private deleteSlot(slot: MScheduleSlot) {
        try {
            if (slot.id) {
                this.meetingsRepository.deleteSlot(slot.id);
            }

            slot.isNotAvailable = false;
        }
        catch(e) {
            this.handleError(e);
        }
    }

    private handleError(e: any) {

        const { response } = e as AxiosError<BackendErrorInterface>;

        if (response?.data.code === "needRights") {
            return showNeedRightsModal();
        }

        if (MeetingsError.isValid(response?.data.code || "")) {
            new MeetingsError(response?.data.code as MeetingsErrorCode, response?.data.message || "").showModal();
        }
        else {
            this.store.dispatch('reportError', e);
        }
    }
}